<div class="flex h-screen overflow-hidden bg-slate100 text-slate900 dark:bg-slate900 dark:text-white">
  <div class="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">

    <app-portal-topbar></app-portal-topbar>

    <div class="flex min-h-0 flex-1 overflow-hidden">
      <app-portal-sidebar
        class="hidden h-full shrink-0 lg:block"
        [collapsed]="sidebarCollapsed()"
        (toggleCollapse)="toggleSidebar()"
      ></app-portal-sidebar>

      <div class="flex min-h-0 min-w-0 flex-1 overflow-hidden">
        <main class="min-h-0 flex-1 overflow-y-auto overflow-x-hidden px-7 py-6">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>

  </div>
</div>
